import { ref } from 'vue';

/**
 * Композабл для управления сворачиваемыми блоками
 * 
 * @param {boolean} initialState - Начальное состояние (по умолчанию развернуто)
 * @returns {Object} - Объект с состоянием и методами управления
 */
export function useCollapsible(initialState = true) {
  // Состояние: развернуто (true) или свернуто (false)
  const isExpanded = ref(initialState);

  /**
   * Переключение состояния блока
   */
  const toggle = () => {
    isExpanded.value = !isExpanded.value;
  };

  /**
   * Развернуть блок
   */
  const expand = () => {
    isExpanded.value = true;
  };

  /**
   * Свернуть блок
   */
  const collapse = () => {
    isExpanded.value = false;
  };

  return {
    isExpanded,
    toggle,
    expand,
    collapse
  };
}

